module.exports = __webpack_public_path__ + "static/media/ios-calendar.5453e706.svg";